import CharacterSlotSeek from './CharacterSlotSeek';

export default class CharactersListSeek extends Phaser.Group {
  constructor(game, charData) {
    super(game);

    const dx = 150;
    const x0 = -(charData.length - 1) * 0.5 * dx;
    this.slots = {};
    for (let i = 0; i < charData.length; i++) {
      const id = charData[i].id;
      const slot = new CharacterSlotSeek(this.game, id);
      slot.x = x0 + i * dx;
      slot.destX = slot.x;
      this.addChild(slot);
      this.slots[id] = slot;
    }
  }

  setSlotsPositions() {
    let count = 0;
    for (const key in this.slots) {
      if (this.slots.hasOwnProperty(key)) {
        count++;
      }
    }

    const dx = 150;
    const x0 = -(count - 1) * 0.5 * dx;
    let i = 0;
    for (const key in this.slots) {
      if (this.slots.hasOwnProperty(key)) {
        this.slots[key].destX = x0 + i * dx;
        i++;
      }
    }
  }

  revealCharacter(characterId) {
    this.slots[characterId].revealCharacter();

    this.game.time.events.add(1000, this.handleRevealEnd, this, characterId);
  }

  handleRevealEnd(characterId) {
    delete this.slots[characterId];
    this.setSlotsPositions();
  }

  enlargeCharacter(characterId) {
    this.slots[characterId].enlarge();
  }

  normalizeCharacter(characterId) {
    this.slots[characterId].normalize();
  }

  pulseCharacter(characterId, repeat) {
    this.slots[characterId].pulse(repeat);
  }

  getSlotForCharacter(characterId) {
    return this.slots[characterId];
  }

  lock() {
    for (const key in this.slots) {
      if (this.slots.hasOwnProperty(key)) {
        const slot = this.slots[key];
        if (!slot.isEmpty) {
          slot.lock();
        }
      }
    }
  }

  unlock() {
    for (const key in this.slots) {
      if (this.slots.hasOwnProperty(key)) {
        const slot = this.slots[key];
        if (!slot.isEmpty) {
          slot.unlock();
        }
      }
    }
  }
}
